module.exports = __webpack_public_path__ + "static/media/phone_long.04b228c8.png";